export const modulePathMapping = Object.freeze({
  SalesReports: "/salesstats",
  ProductItemsStock: "/product-items-stock",
  Assisted: "/retail/:storeName",
  InventoryManagement: [
    "/inventory",
    "/inventory/daily-stock",
    "/inventory/restock",
    "/inventory/archive",
    "/inventory/history",
  ],
  BeginningEndingInventory: ["/inventory", "/inventory/daily-stock"],
  RestockOnly: ["/inventory", "/inventory/restock"],
  MenuItemsCreation: ["/menucreation", "/menucreation/archived"],
  Access: "/access-management",
  AccountManagement: "/account-management",
  Reports: [
    "/reports",
    "/reports/records",
    "/reports/system-logs",
    "/reports/bill-inventory",
    "/reports/bill-history",
    "/reports/customer-details",
    "/reports/customer-history",
  ],
  Customer: "/customers",
  Configuration: [
    "/config",
    "/config-print",
    "/config-service-charge",
    "/config-gross-sales",
    "/config-kiosk",
    "/config-kds",
    "/config-terms",
  ],
  Views: [
    "/views",
    "/views/kitchen",
    "/views/front",
    "/views/tables",
    "/views/claiming",
    "/:posId",
    "/:posId/order",
  ],
  Vouchers: "/vouchers",
  OTPGeneration: ["/account-management/otps"],
  Promotions: [
    "/promotions",
    "/promotions/home",
    "/promotions/brands",
    "/promotions/sounds",
    "/promotions/colors",
  ],
  "OTP Generation": ["/account-management/otps"],
  "Toggle Features": ["/account-management/toggles"],
});

const reservedStoreRouteSegments = new Set(
  Object.values(modulePathMapping)
    .flat()
    .filter((path) => !path.includes(":"))
    .map((path) => path.split("/").filter(Boolean)[0])
);

const canMatchStoreRoute = (currentPath) => {
  const segments = currentPath.split("/").filter(Boolean);
  const firstSegment = segments[0];

  return Boolean(firstSegment) && !reservedStoreRouteSegments.has(firstSegment);
};

const matchPath = (allowedPath, currentPath) => {
  if (allowedPath === "/:posId") {
    return canMatchStoreRoute(currentPath) && /^\/[^/]+$/.test(currentPath);
  }

  if (allowedPath === "/:posId/order") {
    return canMatchStoreRoute(currentPath) && /^\/[^/]+\/order$/.test(currentPath);
  }

  if (allowedPath === "/retail/:storeName") {
    return /^\/retail\/[^/]+$/.test(currentPath);
  }

  return allowedPath === currentPath;
};

const hasModuleForPath = (modules, pathname) =>
  modules.some((module) => {
    const paths = modulePathMapping[module?.name || module?.module || module];
    if (!paths) return false;

    return Array.isArray(paths)
      ? paths.some((allowedPath) => matchPath(allowedPath, pathname))
      : matchPath(paths, pathname);
  });

export const canAccessRoute = ({ user, pathname }) => {
  if (!user) return false;
  if (user.role === "Superadmin") return true;
  if (pathname === "/dashboard" || pathname === "/account-management") {
    return true;
  }
  if (pathname.startsWith("/admin-dashboard")) {
    return Boolean(user.inhouseAdmin);
  }

  return hasModuleForPath(user.modules || [], pathname);
};
